module.exports = __webpack_public_path__ + "img/logo.76d358a6.png";